document.addEventListener('DOMContentLoaded', () => {
  const ugcSlider = document.querySelector('.ugc');

  if (ugcSlider) {
    const data = document.querySelector(`.swiper-data-handler`);
    const sectionId = data.dataset.section;
    const pagination = (data.dataset.pagination);
    const buttons = (data.dataset.buttons);
		const autoplay = (data.dataset.autoplay);
    let colsDesktop = Number(data.dataset.colDesktop);
		let colsMobile = Number(data.dataset.colMobile);
		let colsTablet = Number(data.dataset.colTablet);
		const delay = Number(data.dataset.delay)*1000;
		const speed = Number(data.dataset.speed);

    const autoplayObj = {
			delay: delay,
			disableOnInteraction: true,
			pauseOnMouseEnter: true,
		};

    const swiperObject = {
      slidesPerView: colsMobile,
      loop: true,
      speed: speed,
      centeredSlides: true,
      breakpoints: {
				768: {
					slidesPerView: colsTablet,
				},
				1440: {
					slidesPerView: colsDesktop,
				},
			},
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function(){
          const activeIndex = this.activeIndex;
          const activeSlide = ugcSlider.getElementsByClassName('swiper-slide')[activeIndex];
          const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          activeSlideVideo.onended = function() {
            swiper.slideNext();
          };
        },
        slideChange: function(){
          const videos = ugcSlider.querySelectorAll('video');
          Array.prototype.forEach.call(videos, function(video){
            video.pause();
          });
          const activeIndex = this.activeIndex;
          const activeSlide = ugcSlider.getElementsByClassName('swiper-slide')[activeIndex];
          const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          activeSlideVideo.play();
          activeSlideVideo.onended = function() {
            swiper.slideNext();
          };
        },
      }
    }

    if (autoplay === 'true') {
			swiperObject.autoplay = autoplayObj;
		}
    
    const swiper = new Swiper('.ugc', swiperObject);
  }
});